import Vue from 'vue'
import Cookies from 'js-cookie'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(Element)
// 注册滚动条加载触发事件v-loadmore绑定
import './directives'
import './assets/styles/element-variables.scss'

import '@/assets/styles/index.scss' // global css
import '@/assets/styles/gtiger.scss' // gtiger css
import App from './App.vue'
import router from './router'
import store from './store'

import request from '@/utils/request'
// 全局方法挂载
Vue.prototype.request = request

Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
// .$mount('#app')
